class FAQAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.headers = this.querySelectorAll('.accordion-header');

    this.headers.forEach((header) => {
      header.addEventListener('click', () => this.toggleAccordion(header));
    });
  }

  toggleAccordion(header) {
    const item = header.closest('.accordion-item');
    const isExpanded = item.classList.contains('expanded');

    this.querySelectorAll('.accordion-item').forEach((i) => i.classList.remove('expanded'));

    if (isExpanded) {
      item.classList.remove('expanded');
    } else {
      item.classList.add('expanded');
    }
  }
}

// Register the custom element
customElements.define('faq-accordion', FAQAccordion);
